import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  League,
  LeagueListElement,
  Team,
  TeamListElement,
  TeamListWithoutLeagues,
  TeamSmall
} from "../../../../client/api";
import { getMainLeague } from "../../../../config/utils";

import MatchScoreDisplay from "../../Match/MatchScoreDisplay";
import { showTranslated } from "../../../../config/translator";
import EmblemImage from "../../EmblemImage";
import { selectLanguageOrDefault } from "../../../../selectors";
import ScaleFade from "../../Animated/ScaleFade";

type TeamNameProps = {
  team: Team | TeamListElement | TeamListWithoutLeagues | TeamSmall;
  live?: boolean;
  goal?: number;
  primary?: boolean;
  bold?: boolean;
  admin?: boolean;
  leagues?: League[] | LeagueListElement[];
  alignTop?: boolean;
  size?: "base" | "lg" | "xl";
};

const TeamName: React.FC<TeamNameProps> = ({
                                             team,
                                             admin,
                                             live,
                                             primary,
                                             bold,
                                             goal,
                                             leagues,
                                             alignTop,
                                             size = "xl"
                                           }) => {
  const l = useSelector(selectLanguageOrDefault);
  const mainLeague = useMemo(
    () => (leagues ? getMainLeague(leagues) : undefined),
    [leagues]
  );
  return (
    <div className={`flex flex-row ${alignTop ? "items-start" : "items-center"} my-0.5`}>
      <div className={`flex flex-row ${alignTop ? "items-start" : "items-center"} justify-start flex-1 min-w-0`}>
        <ScaleFade isOpen hover>
          <EmblemImage
            image={"emblem" in team ? team.emblem : undefined}
            imageUrl={"emblemUrl" in team ? team.emblemUrl : undefined}
            width={24}
            className={`mr-2 ${alignTop ? "mt-0.5" : ""}`}
          />
        </ScaleFade>
        <span
          className={`${
            primary ? "text-primary" : "text-font dark:text-font-dark"
          } ${bold ? "font-bold" : ""} ${
            size === "base" ? "text-xs" : size === "lg" ? "text-sm" : "text-base"
          } truncate whitespace-nowrap`}
        >{`${admin ? `[${team.id}]` : ""}${showTranslated(
          team.name,
          l
        )}`}</span>
        {mainLeague && (
          <span
            className={`${
              primary ? "text-primary" : "text-font-600 dark:text-font-600-dark"
            } text-xs`}
          >
            {`${admin ? `[${mainLeague.id}]` : ""}${showTranslated(
              mainLeague.name,
              l
            )}`}
          </span>
        )}
      </div>
      {goal !== undefined ? (
        <div className="w-10 flex items-center justify-center ml-3">
          <MatchScoreDisplay
            goal1={goal}
            className={`text-base font-semibold ${
              live ? "text-red" : "text-font dark:text-font-dark"
            }`}
          />
        </div>
      ) : null}
    </div>
  );
};

export default TeamName;
